/**
 * Created by Ivan on 07.07.2026
 */

const PuzzleStickerView = function (sticker, options) {
    options = options || {};

    return Prefab.instantiate(bundles.sticker.jsons.puzzle_sticker_prefab_json, {
        sticker,
        placeholder: options.placeholder,
        withUpdate: options.withUpdate
    });
};
